import {getMediaUrl} from '@/shared/lib/getMediaUrl';
import {type LocalizationKey} from '@/shared/services/i18n';

type LoginMembersCard = {
  image: string;
  textKey: LocalizationKey;
  name: string;
  firstCode: string;
  secondCode: string;
};

export const LOGIN_MEMBERS_CARD: LoginMembersCard[] = [
  {
    image: getMediaUrl('landing/Josh.webp'),
    textKey: 'landing_members_genesis_dream_text',
    name: 'Josh',
    firstCode: 'CO',
    secondCode: 'US',
  },
  {
    image: getMediaUrl('landing/Mona.webp'),
    textKey: 'landing_members_thanks_bumpy_text',
    name: 'Mona',
    firstCode: 'IN',
    secondCode: 'PH',
  },
  {
    image: getMediaUrl('landing/Damian.webp'),
    textKey: 'landing_members_began_bump_text',
    name: 'Damian',
    firstCode: 'AR',
    secondCode: 'CO',
  },
  {
    image: getMediaUrl('landing/Shakila.webp'),
    textKey: 'landing_members_he_brazil_text',
    name: 'Shakila',
    firstCode: 'LK',
    secondCode: 'BR',
  },
];
